export default __webpack_public_path__ + "static/media/Thaumaturge's Boots of Regal Might.1fbe0629.jpg";